(function () {
  if (window.__rcJdgmCartBadgeInit) return;
  window.__rcJdgmCartBadgeInit = true;

  var BADGE_SELECTOR = ".scd-item__reviews .jdgm-widget.jdgm-preview-badge";
  var DRAWER_SELECTOR = "#CartDrawer, .sf-cart-drawer, [data-cart-drawer], .m-cart-drawer";

  var observer = null;
  var rafId = null;
  var pendingRoots = new Set();

  function extractCount(text) {
    var match = (text || "").replace(/\u00A0/g, " ").match(/(\d[\d\s.,]*)/);
    return match ? match[1].replace(/[^\d]/g, "") : "";
  }

 function formatBadge(badge) {
    if (!badge || badge.dataset.rcFormatted === "1") return;

    var container = badge.closest(".scd-item__reviews");
    var starsEl = badge.querySelector(".jdgm-prev-badge__stars[data-score]");
    if (!starsEl) {
      badge.style.display = "none";
      return;
    }

    var score = starsEl.getAttribute("data-score");
    if (!score) {
      badge.style.display = "none";
      return;
    }

    var textEl = badge.querySelector(".jdgm-prev-badge__text");
    var count = extractCount(textEl ? textEl.textContent : "");

    if (!count || count === "0") {
      badge.style.display = "none";
      return;
    }

    badge.style.display = "";

    var meta = badge.querySelector(".rc-jdgm-badge-meta");
    if (!meta) {
      meta = document.createElement("span");
      meta.className = "rc-jdgm-badge-meta";
      starsEl.insertAdjacentElement("afterend", meta);
    }

    meta.textContent = score + " (" + count + ")";
    if (textEl) textEl.style.display = "none";

    badge.dataset.rcFormatted = "1";
  }

  function scan(root) {
    if (!root) return;
    if (root.matches && root.matches(".jdgm-widget.jdgm-preview-badge")) {
      formatBadge(root);
    }
    var list = root.querySelectorAll ? root.querySelectorAll(BADGE_SELECTOR) : [];
    for (var i = 0; i < list.length; i++) formatBadge(list[i]);
  }

  function scheduleScan(root) {
    pendingRoots.add(root || document);
    if (rafId) return;

    rafId = requestAnimationFrame(function () {
      pendingRoots.forEach(scan);
      pendingRoots.clear();
      rafId = null;
    });
  }

  function getDrawerRoot() {
    return document.querySelector(DRAWER_SELECTOR) || document.body;
  }

  function attachObserver() {
    var target = getDrawerRoot();
    if (!target) return;

    if (observer) observer.disconnect();

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scheduleScan(added[j]);
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
    scheduleScan(target);
  }

  function boot() {
    attachObserver();

    var events = ["cart:updated", "cart-drawer:updated", "cart:refresh", "shopify:section:load"];
    for (var i = 0; i < events.length; i++) {
      document.addEventListener(events[i], function () {
        attachObserver();
        scheduleScan(getDrawerRoot());
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();